// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types } from './types';

export function sguClear(): ReducerAction {
	return {
		type: Types.SGU_CLEAR,
		payload: null,
	};
}
